'use client'

import { Digioh } from '@src/utils/Digioh'
import { Osano } from '@src/utils/Osano'
import { useAnalytics } from '@src/utils/analytics.util'
import { useDataDog } from '@src/utils/datadog.util'
import { useUrlTracker } from '@src/utils/flow-router.client.util'
import { useGeolocation } from '@src/utils/geolocation'
import { GoogleTagManager } from '@src/utils/googleTagManager.util'
import { interceptConsole } from '@src/utils/log.util'

export interface InitContext {
  vercelDeploymentUrl: string
}

export function Init(initContext: InitContext) {
  interceptConsole()
  useDataDog(initContext)
  useAnalytics()
  useGeolocation()
  useUrlTracker()
  return (
    <>
      <Osano />
      <GoogleTagManager />
      <Digioh />
    </>
  )
}
